import React from 'react';
import { usePermissions } from '../app/hooks/custom/usePermissions';

interface PermissionWrapperProps {
    screen?: string;
    permission?: 'view' | 'create' | 'update' | 'delete';
    fallback?: React.ReactNode;
    children: React.ReactNode;
}

export const PermissionWrapper: React.FC<PermissionWrapperProps> = ({
    screen,
    permission = 'view',
    fallback = null,
    children
}) => {
    const { hasScreenPermission, effectivePermissions } = usePermissions(PermissionWrapper.name);

    // Platform admins have access to all screens
    if (effectivePermissions?.isPlatformAdmin) {
        return <>{children}</>;
    }

    if (screen && !hasScreenPermission(screen, permission)) {
        return <>{fallback}</>;
    }

    return <>{children}</>;
}; 